export default {
  setCSRFToken: (state, csrf) => {
    state.CSRFToken = csrf;
  },
  setWindowData: (state, windowData) => {
    state.window = windowData;
  },
  setBreadcrumbsData(state, breadcrumbsData) {
    state.breadcrumbsData = breadcrumbsData;
  },
  setCommonDialog: (state, dialogData) => {
    state.dialog = {
      ...state.dialog,
      ...dialogData
    };
  },
  setUpdateArchFlag(state, flag) {
    state.updateArchFlag = flag;
  },
  setArchFlag(state, flag) {
    state.archFlag = flag;
  },
  setTabFocused(state, payload) {
    state.tabFocused = payload;
  },
  setTestListingDraggingItem(state, payload) {
    state.testListingDraggingItem = payload;
  },
  setInvalidRoute(state, payload) {
    state.invalidRoute = payload;
  },
  resetCheckAccessInfo(state, payload) {
    let localWindow
    try {
      localWindow = JSON.parse(JSON.stringify(state.window))
    } catch {
      localWindow = {}
    }
    localWindow.checkAccessInfo.invalid_access = payload
    state.window = localWindow;
  },
};
